'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var iconStyles = require('../iconStyles.js');
var SvgIcon = require('../../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ServicePlanAppIcon = function ServicePlanAppIcon(props) {
  return React__default["default"].createElement(SvgIcon["default"], _objectSpread({}, props, {
    viewBox: "0 0 53 59.04",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }), React__default["default"].createElement("title", null, "Product-Icon-Set-103018"), React__default["default"].createElement("rect", {
    x: "18.92",
    y: "8.22",
    width: "22.02",
    height: "1.2"
  }), React__default["default"].createElement("rect", {
    x: "7.44",
    y: "14.5",
    width: "33.49",
    height: "1.2"
  }), React__default["default"].createElement("rect", {
    x: "7.44",
    y: "20.78",
    width: "33.49",
    height: "1.2"
  }), React__default["default"].createElement("rect", {
    x: "7.44",
    y: "27.06",
    width: "33.49",
    height: "1.2"
  }), React__default["default"].createElement("rect", {
    x: "7.44",
    y: "33.34",
    width: "33.49",
    height: "1.2"
  }), React__default["default"].createElement("rect", {
    x: "7.44",
    y: "39.39",
    width: "27.03",
    height: "1.2"
  }), React__default["default"].createElement("path", {
    d: "M15.25,49.48,14.14,49c.25-.58,1.54-3.47,3.24-3.47,1.21,0,1.58,1.08,1.83,1.79a2.9,2.9,0,0,0,.27.63h0c.12,0,.2-.06.43-.29a1.46,1.46,0,0,1,1.32-.57,2,2,0,0,0,.35,0c.34,0,.49.08,1,.41a6.52,6.52,0,0,1,.55.39l.16.12.28-.15a2.61,2.61,0,0,1,2.72-.42c.42.14.79.3,1.12.44a4,4,0,0,0,.9.32h0l.24,1.17A2.81,2.81,0,0,1,27,49c-.31-.13-.66-.28-1-.4-.79-.27-.93-.18-1.69.28s-1.27.41-1.83,0a3.76,3.76,0,0,0-.43-.31l-.4-.24a2.06,2.06,0,0,1-.56,0s-.1,0-.28.23a1.69,1.69,0,0,1-1.45.63c-.76-.08-1-.82-1.23-1.42s-.39-1-.7-1C16.74,46.74,15.73,48.33,15.25,49.48Z"
  }), React__default["default"].createElement("polygon", {
    points: "11.06 47.64 12.24 48.82 11.4 49.67 10.22 48.49 9.04 49.67 8.19 48.82 9.37 47.64 8.19 46.46 9.04 45.62 10.22 46.8 11.4 45.62 12.24 46.46 11.06 47.64"
  }), React__default["default"].createElement("path", {
    d: "M46.19,29.21V2.07a.53.53,0,0,0-.53-.53H12.42A.55.55,0,0,0,12,1.7l-.11.12v9.49a.54.54,0,0,1-.55.55H2.52l-.18.2a.5.5,0,0,0-.14.37V55.79a.53.53,0,0,0,.53.53H45.66a.53.53,0,0,0,.53-.53v-14a1.75,1.75,0,0,0,1.2-.49V55.79a1.74,1.74,0,0,1-1.73,1.73H2.73A1.73,1.73,0,0,1,1,55.79V12.43a1.72,1.72,0,0,1,.46-1.18L11.16.89A1.74,1.74,0,0,1,12.42.34H45.66a1.73,1.73,0,0,1,1.73,1.73v26a2.61,2.61,0,0,0-.31.27Z"
  }), React__default["default"].createElement("polygon", {
    points: "42.18 40.75 34.71 48.23 30.77 49.25 31.79 45.31 39.26 37.83 42.18 40.75"
  }), React__default["default"].createElement("path", {
    d: "M51.82,35.22l-5.23,5.23a.58.58,0,0,1-.4.17h0a.62.62,0,0,1-.44-1.05l.47-.47,1.2-1.19,3.13-3.13L49.33,33.6,43,39.9,40.11,37l7.82-7.82a2.11,2.11,0,0,1,.87-.52,2.66,2.66,0,0,1,.39-.07h.4a2.66,2.66,0,0,1,.39.07,2.11,2.11,0,0,1,.87.52,2.08,2.08,0,0,1,0,2.92l-.66.66,1.63,1.62A.62.62,0,0,1,51.82,35.22Z"
  }), React__default["default"].createElement("path", {
    d: "M40.86,34.54h.08v-.08Z"
  }));
};

var ServicePlanAppIcon$1 = iconStyles()(ServicePlanAppIcon);

module.exports = ServicePlanAppIcon$1;
